import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthenticationService } from '../services/authentication.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { LocalService } from '../services/local.service';

declare var AppleID;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  public submitted = false;
  public form: FormGroup;
  error: string;
  public id;
  loading = false;
  public isChecked: any;
  spinnerType = SPINNER.circle;
  rememberMe: Boolean;
  showPassword: boolean = false;
  constructor(
    private ngxService: NgxUiLoaderService,
    public router: Router,
    public authenticationService: AuthenticationService,
    public fb: FormBuilder,
    private localStore: LocalService
  ) {
    this.form = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required, Validators.minLength(6)]],
      rememberMe: [false],
      acceptTerms: [false, Validators.requiredTrue],
    });
  }

  ngOnInit(): void {
    const email = this.localStore.getData('merchantEmail');
    const password = this.localStore.getData('merchantPassword');
    this.rememberMe = !!email && !!password;
    this.localStore.getData('merchantEmail') && !!this.localStore.getData('merchantPassword');
    
    // Load saved terms acceptance state
    const savedTermsAccepted = this.localStore.getData('termsAccepted');
    const termsAccepted = savedTermsAccepted === 'true';
    
    this.form.patchValue({
      email: email || '',
      password: password || '',
      acceptTerms: termsAccepted,
    });
  }
  get f() {
    return this.form.controls;
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  private ensureTermsAccepted(): boolean {
    this.submitted = true;
    const accepted = this.form.get('acceptTerms')?.value;
    if (!accepted) {
      Swal.fire({
        toast: true,
        position: 'top',
        icon: 'warning',
        title:
          "Please accept the Terms of Service and Privacy Policy to continue.",
        showConfirmButton: false,
        timer: 3000,
      });
      return false;
    }
    return true;
  }

  socialLogin(obj) {
    localStorage.removeItem('merchant_currentUser1');
    this.ngxService.start();
    this.authenticationService.loginWithSocailMedia(obj).subscribe(
      (data) => {
        this.ngxService.stop();
        let user = JSON.parse(localStorage.getItem('merchant_currentUser1'));
        if (user.isEmailVarified == true && user.isFirstUpdateDone == true) {
          this.router.navigate(['/dashboard']);
          Swal.fire('', 'User is logged in sucessfully.', 'success');
        } else if (
          user.isFirstUpdateDone == false &&
          user.isEmailVarified == false
        ) {
          this.router.navigate(['/user-registration']);
          Swal.fire('', 'Please complete your registration', 'success');
        } else if (
          user.isFirstUpdateDone == true &&
          user.isEmailVarified == false
        ) {
          this.router.navigate(['/email-verification']);
          Swal.fire('', 'Please verify your email.', 'success');
        }
      },
      (error) => {
        localStorage.removeItem('merchant_user');
        this.ngxService.stop();
        if (error) {
          Swal.fire('Error', error.error.message, 'error');
        }
      }
    );
  }

  checkTermsAndConditions() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover your account!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
      }
    });
  }

  public googleLogin() {
    if (!this.ensureTermsAccepted()) {
      return;
    }
    this.isChecked = localStorage.getItem('checked')
    localStorage.removeItem('token');
    localStorage.removeItem('merchant_currentUser1');
    this.authenticationService.doGoogleLogin().then(
      (data) => {
        this.authenticationService.GetToken().then(
          (userToken) => {
            let info = {
              email: data.additionalUserInfo.profile.email,
              name: data.additionalUserInfo.profile.name,
            };
            localStorage.setItem('merchant_user', JSON.stringify(info));
            let obj = {
              deviceType: 'web',
              deviceId: 'ravel-merchant',
              version: '1.0',
              role: 'Merchant',
              socialType: 'google',
              token: userToken,
            };
            this.socialLogin(obj);
          },
          (error) => {
            if (error) {
              Swal.fire('error', 'Oops...', error.error.message);
            }
          }
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  public facebookLogin() {
    if (!this.ensureTermsAccepted()) {
      return;
    }
    this.isChecked = localStorage.getItem('checked');
    this.authenticationService.doFacebookLogin().then(
      (data) => {
        this.authenticationService.GetToken().then(
          (userToken) => {
            let info = {
              email: data.additionalUserInfo.profile.email,
              name: data.additionalUserInfo.profile.name,
            };
            localStorage.setItem('merchant_user', JSON.stringify(info));
            let obj = {
              deviceType: 'web',
              deviceId: '1',
              version: '1.0',
              role: 'Merchant',
              socialType: 'facebook',
              token: userToken,
            };
            this.socialLogin(obj);
          },
          (error) => {
            if (error) {
              Swal.fire('error', 'Oops...', error.error.message);
            }
          }
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  }

  public async appleLogin() {
    if (!this.ensureTermsAccepted()) {
      return;
    }
    try {
      AppleID.auth.init({
        clientId: 'com.ravel.fellowship',
        scope: 'name email',
        redirectURI: 'https://ravel-merchant.firebaseapp.com/__/auth/handler',
        state: 'origin:web',
        // usePopup: true
      });
      const data = await AppleID.auth.signIn();
      console.log(this.parseJwt(data.authorization.id_token));
    } catch (error) {
      console.log(error);
      //handle error.
    }
  }

  redirect() {
    let isChecked = localStorage.getItem('checked');
    if (isChecked) {
      this.router.navigateByUrl('/sign-in');
    } else {
      Swal.fire(
        '',
        'Please select our terms of services and privacy policy to continue.',
        'error'
      );
    }
  }

  public onSubmit(values: Object): void {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    if (this.form.valid) {
      let email = this.form.get('email').value;
      let password = this.form.get('password').value;
      // this.rememberMe = this.form.get('password').value
      let deviceType = 'web';
      let version = '1';
      let role = 'Merchant';
      let obj = {
        email: email,
        password: password,
        deviceType: deviceType,
        version: version,
        role: role,
      };
      this.ngxService.start();
      this.authenticationService.login(obj).subscribe(
        (data) => {
          this.ngxService.stop();
          localStorage.setItem('merchant_id', data._id);
          this.id = data._id;
          let user = JSON.parse(localStorage.getItem('merchant_currentUser1'));
          if (user.isEmailVarified == true && user.isFirstUpdateDone == true) {
            if (this.rememberMe) {
              this.localStore.saveData('merchantEmail', email);
              this.localStore.saveData('merchantPassword', password);
              localStorage.setItem('rememberMe', this.form.value.rememberMe);
            } else {
              this.localStore.removeData('merchantEmail');
              this.localStore.removeData('merchantPassword');
              this.localStore.removeData('rememberMe');
            }
            this.router.navigate(['/dashboard']);
            Swal.fire('', 'User is logged in sucessfully.', 'success');
          } else if (
            user.isEmailVarified == false &&
            user.isFirstUpdateDone == false
          ) {
            let info = { email: email, name: '' };
            localStorage.setItem('merchant_user', JSON.stringify(info));
            this.router.navigate(['/user-registration']);
            Swal.fire('', 'Please complete your registration.', 'success');
          } else if (
            user.isEmailVarified == false &&
            user.isFirstUpdateDone == true
          ) {
            let info = { email: email, name: '' };
            localStorage.setItem('merchant_user', JSON.stringify(info));
            this.router.navigate(['/email-verification']);
            Swal.fire('', 'Please verify your email.', 'success');
          }
        },
        (error) => {
          this.ngxService.stop();
          if (error.status == 401) {
            localStorage.removeItem('merchant_currentUser1');
          } else {
            Swal.fire('Login Method', error.error.message, 'error');
          }
        }
      );
    }
  }
  
  // Handles explicit click from the Sign in button to show a toast when terms are not accepted
  onLoginClick() {
    this.submitted = true;
    const accepted = this.form.get('acceptTerms')?.value;
    if (!accepted) {
      Swal.fire({
        toast: true,
        position: 'top',
        icon: 'warning',
        title:
          "Please accept the Terms of Service and Privacy Policy to continue.",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }
    // If terms accepted, delegate to existing submit which validates and logs in
    this.onSubmit(this.form.value);
  }
  onAcceptTermsChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.form.get('acceptTerms')?.setValue(checked);
    this.form.get('acceptTerms')?.markAsTouched(); // optional: marks control as touched for validation
    
    // Save terms acceptance state to localStorage
    if (checked) {
      this.localStore.saveData('termsAccepted', 'true');
    } else {
      this.localStore.removeData('termsAccepted');
    }
  }
  signup() {
    this.router.navigate(['sign-up']);
  }
}
